import React from "react";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

interface ErrorBannerProps {
  message: string;
}

const ErrorBanner: React.FC<ErrorBannerProps> = ({ message }) => (
  <div className="ds-error-banner">
    <ErrorOutlineIcon fontSize="small" />
    <span>{message}</span>
  </div>
);

export default ErrorBanner;
